import {
  AuditionRequestIcon,
  CheckInIcon,
  ProjectsIcon,
  ResumeIcon,
  SelfTapesIcon,
  Typography,
  UpcomingAuditionIcon,
} from '@room-match/shared-ui-components';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import CustomTypography from 'shared/elements/CustomTypography/CustomTypography';
import { useAppSelector } from 'shared/redux/store';
import NewImage from '../NewImage';
import DashboardItem from './DashboardItem/DashboardItem';
import {
  ActionButton,
  ActionButtonTwoRowLabel,
  DashboardItemsContainer,
  FlexContainer,
  MainContainer,
  Top,
} from './DashboardMobile.styles';
import { COLORS } from 'shared/constants/COLORS';

const DashboardMobile: React.FC = () => {
  const {
    app: appState,
    user: { user },
  } = useAppSelector((state) => state);
  const { isGuardian, guardianUI } = appState.guardian;

  const DashboardItems = [
    {
      icon: <AuditionRequestIcon pathColor="#f7bc02" />,
      name: 'Audition Requests',
      link: `${ROUTES.TALENT.AUDITIONS}/audition_request`,
      count: user?.attributes.audition_requests_count || 0,
    },
    {
      icon: <UpcomingAuditionIcon />,
      name: 'Upcoming Auditions',
      link: `${ROUTES.TALENT.AUDITIONS}/audition_history`,
      count: user?.attributes.upcoming_auditions_count || 0,
    },
    {
      icon: <SelfTapesIcon pathColor={COLORS.PRIMARY} />,
      name: 'Submit Self Tapes',
      link: `${ROUTES.TALENT.SELFTAPES}`,
      count: user?.attributes.self_tapes_count || 0,
    },
    {
      icon: <CheckInIcon />,
      name: 'Check-In',
      link: ROUTES.TALENT.CHECKIN,
      count: 0,
    },
  ];

  const history = useHistory();

  return (
    <MainContainer>
      <Top>
        <NewImage src={user?.attributes.picture} />
        <span style={{ fontSize: 30, fontWeight: 500 }}>Welcome {user?.attributes.stage_first_name}</span>
        {isGuardian ? (
          <Typography color="darkGrey" style={{ fontStyle: 'italic', marginTop: -10 }}>
            (Guardian)
          </Typography>
        ) : (
          <React.Fragment />
        )}
      </Top>
      {guardianUI ? (
        <React.Fragment />
      ) : (
        <React.Fragment>
          <DashboardItemsContainer>
            {DashboardItems.map((i) => (
              <DashboardItem icon={i.icon} label={i.name} count={i.count} isLoading={false} link={i.link} />
            ))}
          </DashboardItemsContainer>
          <FlexContainer>
            <ActionButton onClick={() => history.push(`${ROUTES.TALENT.MEDIA}/dashboard`)} startIcon={<ProjectsIcon />}>
              <ActionButtonTwoRowLabel>
                <CustomTypography fontSize={18} fontWeight={600}>
                  Manage My Media
                </CustomTypography>
                <CustomTypography fontSize={12}>Upload images, videos etc…</CustomTypography>
              </ActionButtonTwoRowLabel>
            </ActionButton>
            <ActionButton
              onClick={() => history.push(`${ROUTES.TALENT.MYINFO}/general_appearance`)}
              startIcon={<ResumeIcon />}
            >
              <ActionButtonTwoRowLabel>
                <CustomTypography fontSize={18} fontWeight={600}>
                  Edit Resume/ Skills / Sizes/ Social
                </CustomTypography>
                <CustomTypography fontSize={12}>Add your experience, skills, sizes and social reach</CustomTypography>
              </ActionButtonTwoRowLabel>
            </ActionButton>
          </FlexContainer>
        </React.Fragment>
      )}
    </MainContainer>
  );
};

export default DashboardMobile;
